import React, { Component } from 'react';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';

const Url = {
    normal: API_URL.requestDataAnalysis.queryNormalMilestoneUnissuedInvoices,
    anomaly: API_URL.requestDataAnalysis.queryAbnormalMilestoneUnissuedInvoices
};
const limit = 10;

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 11,
            },
            data: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryNormalMilestoneUnissuedInvoices, {
            offset: current,
            limit,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            const remainder = totalCount % limit;
            pagination.total = Math.floor(totalCount / limit) * pageSize + (remainder > 0 ? remainder + (pageSize - limit) : 0);
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            fixed: 'left',
            width: 100,
            render: (text, record) => {
                if (text === '合计')  return text;
                return <a onClick={() => this.handleClick(record)}>{text}</a>;
            }
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeMainCode',
            key: 'investigationJdeMainCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        },{
            title: 'PM',
            dataIndex: 'pmName',
            key: 'pmName',
            width: 140,
            render: (text, record) => {
                const { pmName, pmCode } = record;
                return (pmName && pmCode) ? `${pmName}[${pmCode}]` : ''
            }
        },{
            title: '主领域leader',
            dataIndex: 'mainTalNameCode',
            key: 'mainTalNameCode',
            width: 140,
        },{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 120,
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 80,
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 80,
            render: (text, record) => {
                const { cashReqNodeType, cashReqNodeNum } = record;
                return text ? `${text}${cashReqNodeType ? cashReqNodeType === 'NNF' ? `(${cashReqNodeNum}例)` : `(合同开始后${cashReqNodeNum}天)` : ''}` : '';
            },
        }, {
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: text => format('money', text),
        }, {
            title: 'milestone到达日期',
            dataIndex: 'cashReqNodeDate',
            key: 'cashReqNodeDate',
            width: 100,
            render: text => format('date', text),
        }, {
            title: '确认可请款日期',
            dataIndex: 'baConfirmCashReqDate',
            key: 'baConfirmCashReqDate',
            width: 100,
            render: text => format('date', text),
        }, {
            title: '超出milestone天数',
            dataIndex: 'outCashReqNodeDays',
            key: 'outCashReqNodeDays',
            width: 100,
        }, {
            title: '已记收入未开票',
            dataIndex: 'recordedIncomeNoinvoiced',
            key: 'recordedIncomeNoinvoiced',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '未开票原因',
            dataIndex: 'remark',
            key: 'remark',
            width: 160,
        }];
        return columns;
    }

    handleClick = (record) => {
        const { notice } = this.props;
        const { remittanceCode } = record;
        notice.saveParams({ remittanceCode });
        location.href = '/#/contractManagement/requestRecord';
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    pagination={pagination}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    // className="arrivedMilestone"
                />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/ArrivedMilestone/TablePage/List.js